// extracted by mini-css-extract-plugin
export default {"rating":"jB-z","numberOfStars":"kB-z","count":"lB-z","barGraphSpacing":"mB-z","barGraph":"nB-z"};